import { combineEpics } from 'redux-observable';
import queryChanged from './query-changed/index.tsx';
import retrieveFilters from './retrieve-filters/index.tsx';

export default combineEpics(queryChanged, retrieveFilters);
